import {
  FETCH_LINKED_USERS,
  STORE_LINKED_USERS,
  EDIT_USER,
  DELETE_USER,
  GET_ROLES,
  STORE_ROLES,
  STORE_RFID,
  REGISTER_RFID,
  DELETE_RFID,
  PROCESS_RFID,
  FETCH_LOCATION_DETAIL,
  STORE_LOCATION_DETAIL,
} from '../../constants/userManagement';

export const fetchLinkedUsers = (username) => ({
  type: FETCH_LINKED_USERS,
  username,
});

export const storeLinkedUsers = (users) => ({
  type: STORE_LINKED_USERS,
  users,
});

export const editUser = (userInfo, updatedUserInfo, setState) => ({
  type: EDIT_USER,
  userInfo,
  updatedUserInfo,
  setState,
});

export const deleteUser = (userInfo, setState) => ({
  type: DELETE_USER,
  userInfo,
  setState,
});

export const getRoles = (data) => ({
  type: GET_ROLES,
  data,
});

export const storeRoles = (roles) => ({
  type: STORE_ROLES,
  roles,
});

//RFID
export const registerRFID = (data, callback) => ({
  type: REGISTER_RFID,
  data,
  callback,
});

export const storeRFID = (user) => ({
  type: STORE_RFID,
  user,
});

export const deleteRFID = (data) => ({
  type: DELETE_RFID,
  data,
});

export const processRFID = (data, callback) => ({
  type: PROCESS_RFID,
  data,
  callback,
});

//profile

export const fetchLocationDetail = (data) => ({
  type: FETCH_LOCATION_DETAIL,
  data,
});
export const storeLocationDetail = (data) => ({
  type: STORE_LOCATION_DETAIL,
  data,
});
